import { Spinner } from '@/components';
import { MasterTranslation, SpinnerSize } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ConnectGoogleButton } from '@/modules/pmt/components/ConnectGoogleButton';
import { ESConnectFailedDialog } from '@/modules/pmt/components/ESConnectFailedDialog';
import { useEmailSyncContext } from '@/modules/pmt/context';
import AddIcon from '@/public/images/icons/add.svg';
import { useEffect } from 'react';
import {
  AddEmailAccountButton,
  EmailAccountsContainer,
  EmailAccountsList,
  LoadingWrapper,
} from './EmailAccount.styles';
import { EmailAccountItem } from './components/EmailAccountItem';

export const EmailAccounts = () => {
  const { t } = useGlobalState();
  const { emailSyncData, fetchEmailSyncAccounts, isFetchingEmailAccounts, setIsFetchingEmailAccounts } =
    useEmailSyncContext();

  const emails = emailSyncData?.emails;

  // biome-ignore lint/correctness/useExhaustiveDependencies: intentionally runs once on mount; fetchEmailSyncAccounts is stable
  useEffect(() => {
    (async () => {
      await fetchEmailSyncAccounts();
      setIsFetchingEmailAccounts(false);
    })();
  }, []);

  if (isFetchingEmailAccounts)
    return (
      <LoadingWrapper>
        <Spinner size={SpinnerSize.Small} />
      </LoadingWrapper>
    );

  const AddAccountButton = ({ onClick }: { onClick: () => void }) => (
    <AddEmailAccountButton onClick={onClick}>
      <AddIcon />
      {t(MasterTranslation.AccSyncedEmailsCtaAddEmail)}
    </AddEmailAccountButton>
  );

  return (
    <EmailAccountsContainer>
      <EmailAccountsList>
        {emails?.map((email) => (
          <EmailAccountItem key={email.id} email={email} onToggledEmail={fetchEmailSyncAccounts} />
        ))}
      </EmailAccountsList>
      <ConnectGoogleButton buttonComponent={AddAccountButton} onSuccess={fetchEmailSyncAccounts} />
      <ESConnectFailedDialog />
    </EmailAccountsContainer>
  );
};
